import React from 'react';
import { ScrollReveal } from '../ui/ScrollReveal';
import { XIcon, ZapIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full py-20 md:py-32 px-4 md:px-5" data-id="element-322">
      <div className="max-w-3xl mx-auto" data-id="element-323">
        {/* Headline */}
        <ScrollReveal data-id="element-324">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-4 text-center" data-id="element-325">
            El problema no es tu contenido.{' '}
            <span className="text-accent" data-id="element-326">Es cómo empiezas.</span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.08} data-id="element-327">
          <p className="text-lg md:text-xl text-neutral-400 leading-relaxed mb-12 md:mb-16 text-center max-w-2xl mx-auto" data-id="element-328">
            El primer segundo decide si te ven… o te ignoran.
          </p>
        </ScrollReveal>

        {/* Pain point cards — orange accent borders */}
        <div className="space-y-4" data-id="element-329">
          <ScrollReveal delay={0.05} data-id="element-330">
            <div className="flex gap-4 items-start bg-surface border border-accent/15 rounded-xl p-5 md:p-6 transition-colors duration-200" data-id="element-331">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-accent/10 border border-accent/20 flex items-center justify-center mt-0.5" data-id="element-332">
                <XIcon className="w-4 h-4 text-accent" data-id="element-333" />
              </div>
              <div data-id="element-334">
                <p className="text-white font-bold mb-1" data-id="element-335">
                  Empiezas con "Hola" y nadie se queda
                </p>
                <p className="text-neutral-400" data-id="element-336">
                  El scroll no perdona introducciones genéricas.
                </p>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.1} data-id="element-337">
            <div className="flex gap-4 items-start bg-surface border border-accent/15 rounded-xl p-5 md:p-6 transition-colors duration-200" data-id="element-338">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-accent/10 border border-accent/20 flex items-center justify-center mt-0.5" data-id="element-339">
                <XIcon className="w-4 h-4 text-accent" data-id="element-340" />
              </div>
              <div data-id="element-341">
                <p className="text-white font-bold mb-1" data-id="element-342">
                  No sabes qué decir al inicio
                </p>
                <p className="text-neutral-400" data-id="element-343">
                  Pierdes el momento más importante del video.
                </p>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.15} data-id="element-344">
            <div className="flex gap-4 items-start bg-surface border border-accent/15 rounded-xl p-5 md:p-6 transition-colors duration-200" data-id="element-345">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-accent/10 border border-accent/20 flex items-center justify-center mt-0.5" data-id="element-346">
                <XIcon className="w-4 h-4 text-accent" data-id="element-347" />
              </div>
              <div data-id="element-348">
                <p className="text-white font-bold mb-1" data-id="element-349">
                  Tus videos no generan seguidores ni ventas
                </p>
                <p className="text-neutral-400" data-id="element-350">
                  La gente no se engancha, y el algoritmo tampoco.
                </p>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.2} data-id="element-351">
            <div className="flex gap-4 items-start bg-surface border border-accent/15 rounded-xl p-5 md:p-6 transition-colors duration-200" data-id="element-352">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-accent/10 border border-accent/20 flex items-center justify-center mt-0.5" data-id="element-353">
                <XIcon className="w-4 h-4 text-accent" data-id="element-354" />
              </div>
              <div data-id="element-355">
                <p className="text-white font-bold mb-1" data-id="element-356">
                  Improvisas cada vez que grabas
                </p>
                <p className="text-neutral-400" data-id="element-357">
                  Y eso hace que tus videos mueran antes de empezar.
                </p>
              </div>
            </div>
          </ScrollReveal>
        </div>

        {/* Transition to solution */}
        <ScrollReveal delay={0.3} data-id="element-358">
          <div className="mt-14 md:mt-20 text-center" data-id="element-359">
            <div className="inline-flex items-center gap-2 mb-4" data-id="element-360">
              <ZapIcon className="w-5 h-5 text-accent" data-id="element-361" />
            </div>
            <p className="text-xl md:text-2xl font-extrabold text-white mb-3" data-id="element-362">
              Por eso creamos <span className="text-accent" data-id="element-363">HOOK ARSENAL.</span>
            </p>
            <p className="text-base md:text-lg text-neutral-400 max-w-lg mx-auto leading-relaxed" data-id="element-364">
              200 ganchos listos para usar que capturan atención desde el primer
              segundo.
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}